var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27",
    "data-name": "Group 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.647,
    height: 20.189,
    viewBox: "0 0 25.647 20.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 25.647,
    height: 20.189,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 22.539,
    transform: "translate(3.108 10.094)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M25.647,0c0,6.087-7.052,10.094-10.511,10.094",
    transform: "translate(-15.136 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M25.647,20.189c0-6.087-7.052-10.094-10.511-10.094",
    transform: "translate(-15.136 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/arrowLeftWhite.4d389ebb778a38c61bd1f9f1a1e1b18e.svg";
export { ForwardRef as ReactComponent };